import styled from 'styled-components'

import { ReactComponent as ZipIcon } from '@sketch/icons/zip-51'

export const DownloadIcon = styled(ZipIcon)`
  width: 51px;
  height: 51px;
`
